import React, { Component } from 'react';
import { object } from 'prop-types';
import { Button } from '@mui/material';
import { I18n } from 'utils/i18n';
import messageShape from 'shapes/message';
import connector from './connector';

class DeleteDraftButton extends Component {
  handleDelete = () => {
    const { actions, message } = this.props;
    actions.messages.destroy(message._id);
  };

  render() {
    return (
      <Button
        sx={{
          minWidth: '110px',
          color: '#fd3b36',
          fontSize: '15px',
          mt: '10px',
        }}
        onClick={this.handleDelete}
      >
        {I18n.t('AcknowledgementMessage.Delete draft')}
      </Button>
    );
  }
}

DeleteDraftButton.propTypes = {
  actions: object.isRequired,
  message: messageShape.isRequired,
};

export default connector(DeleteDraftButton);
